import { render, staticRenderFns } from "./resultat-patient.html?vue&type=template&id=4e025d17&scoped=true&external"
import script from "./resultat-patient.js?vue&type=script&lang=js&external"
export * from "./resultat-patient.js?vue&type=script&lang=js&external"
import style0 from "./resultat-patient.scss?vue&type=style&index=0&id=4e025d17&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e025d17",
  null
  
)

export default component.exports